import { Accordion, Box, Spinner } from '@chakra-ui/react'
import { AccordionByMesh } from './model/uiuxComponents/AccordionByMesh'

import { useContext, useEffect, useState } from 'react'
import { IMeshData, IModelDesignData } from '../../../type/designType'
import {
  getProductDesignIdFromURL,
  loadDesignState,
  saveDesignState,
} from '../../../utils/design/saveLoad'
import AddToCartButton from '../../../../cart/components/addToCartButton'
import { AppContext } from '../../../libs/context'

const DesignYourOwn = () => {
  const context = useContext(AppContext)
  const { model } = context

  const designId = getProductDesignIdFromURL() as string

  const [designData, setDesignData] = useState<IModelDesignData | null>(null)

  const setMeshData = (meshData: IMeshData) => {
    if (designData) {
      setDesignData({
        ...designData,
        modelConfig: {
          ...designData.modelConfig,
          meshes: [
            ...designData.modelConfig.meshes.filter(m => m.id !== meshData.id),
            meshData,
          ],
        },
      })
    }
  }

  useEffect(() => {
    loadDesignState(designId, context).then(designState => {
      if (designState) {
        setDesignData(designState)
      }
    })
  }, [])

  useEffect(() => {
    if (designData) {
      saveDesignState(designData)
    }
  }, [designData])

  if (!model?.current) return <Spinner />

  return (
    <Box>
      <Box paddingInline="15px" marginBlockEnd="60px">
        <Box>
          {designData && (
            <Accordion allowMultiple marginInline="-15px">
              {model.current.meshes.map(mesh => (
                <AccordionByMesh
                  key={`accordion-mesh-${mesh.id}`}
                  mesh={mesh}
                  designData={designData}
                  setMeshData={setMeshData}
                />
              ))}
            </Accordion>
          )}
        </Box>
        {designData && (
          <Box
            position="absolute"
            width="calc(100% - 15px)"
            padding="15px"
            marginInlineEnd="15px"
            right="0"
            bottom="0"
            bg="white"
          >
            <AddToCartButton design={designData} model={model.current} />
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default DesignYourOwn
